import { $axios_design_whos, $axios_home, $axios_tomarch } from "lib/axios";
import { TGetTermsHistoriesRes, TGetTermsRes, TServices, TTerms } from "types/terms/termsTypes";

export const getTermsLatest = async (type: TTerms, fetchFrom: TServices) => {
  const res = await (fetchFrom === "ENERGYX"
    ? $axios_home
    : fetchFrom === "TOMARCH"
    ? $axios_tomarch
    : $axios_design_whos
  ).get<TGetTermsRes>(`/terms/latest?type=${type}`);
  return res.data;
};

export const getTermsDetail = async (termsId: number) => {
  const res = await $axios_home.get<TGetTermsRes>(`/terms/${termsId}`);
  return res.data;
};

export const getTermsHistory = async (type: TTerms, fetchFrom: TServices) => {
  const res = await (fetchFrom === "ENERGYX"
    ? $axios_home
    : fetchFrom === "TOMARCH"
    ? $axios_tomarch
    : $axios_design_whos
  ).get<TGetTermsHistoriesRes>(`/terms/history?type=${type}`);
  return res.data;
};
